import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.landingPage.index'),
        name: 'landingPage.index',
        component: () =>
            import(
                /* webpackChunkName: "landing-pages" */ '@/views/landing-pages/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.landingPage.breadcrumb.index'),
                    to: { name: 'landingPage.index' },
                    disable: true,
                },
            ],
            showName: 'Landing Pages',
        },
    },
]
